import moment from "moment";
import momenttimezone from "moment-timezone";
import { forwardRef, useRef, useState, useEffect } from "react";
import Pagination from "../../Controls/Pagination/pagination";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";

const AIAutoLockPendingReqTable = forwardRef(function AIAutoLockPendingReqTable(
  {
    orgAutoLockLstPendingRequestAccess,
    noRecordsFoundPendingAccess,
    language,
    dateFormatValueUpper,
    paginationAttributes,
    onPageChange,
    onNextClick,
    onPrevClick,
    onOpenClick,
    totalPages,
    selectAllAI,
    pageView,
    isClear,
    selectedOption,
    onPageViewDropDown,
    applyTimeZoneToDisplay,
    timeZoneRef,
    timeZoneAbbrevation
  },
  ref
) {
  console.log(ref);
  const allCheckRef = useRef();
  const pageViewRef = useRef();
  const [allChecked, setAllChecked] = useState(false);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(languageChange(localStorage.getItem("language")));
  }, []);
  console.log(totalPages);
  const [istilticonExpand, setIstilticonExpand] = useState(false);
  const handlerMasterSelectionRequest = () => {
    // setAllChecked(!allChecked);
    if (allCheckRef.current.checked) {
      ref.current.map((element) => (element.checked = true));
    } else {
      ref.current.map((element) => (element.checked = false));
    }
  };
  let count = 0;
  useEffect(() => {
    //setAllChecked(selectAllAI);
    if(allCheckRef.current!=null){
    allCheckRef.current.checked = selectAllAI;
    }
    }, [isClear]);
  const handleSelectedAllRequest = (e) => {
    ref.current = ref.current.filter((r) => r !== null);
    for (const element of ref.current) {
      if (element.checked) count++;
      else count--;
    }

    if (ref.current.length === count) {
      //setAllChecked(true);
      allCheckRef.current.checked = true;
    } else {
      allCheckRef.current.checked = false;
    }
  };

  const PrevClick = () => {
    onPrevClick();
    orgAutoLockLstPendingRequestAccess.map(
      (element) => (element.checked = false)
    );
  };
  const NextClick = () => {
    onNextClick();
    orgAutoLockLstPendingRequestAccess.map(
      (element) => (element.checked = false)
    );
  };
  const PageChange = (i) => {
    onPageChange(i);
  };
  function rowclick(id) {
    onOpenClick(id);
  }
  const setpageViewDrp = () => {
    onPageViewDropDown(pageViewRef.current.value);
  };

  const [isSticky, setIsSticky] = useState(false);
  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if((scrollTop) < 135)
      setIsSticky(false);
    else if(scrollTop > 135)
      setIsSticky(true)
  };

  useEffect(() => {
    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className="card-body p-0"
      style={{ paddingRight: "0.15rem !important" }}
    >
     <div className="table-responsive res-card" style={{marginTop: ` ${isSticky ? "47px" : "0px"}`}}>
    <table
          className="fold-table table tablelayout "
          cellPadding="0"
          cellSpacing="0"
>

          {/* <div className={`sticky-section ${isSticky ? 'fixed-accessManage' : ""}`}> */}
          {/*  className={`bg-lightblue sticky-section ${window.scrollY >= stickySection.offsetTop - (-75) ? 'fixed-accessManage' : ""}`} */}
        <thead id="sticky2" className={` ${isSticky ? "bg-lightblue sticky-fixed-accessrquest" : "bg-lightblue"}`}
          style={{ top: ` ${isSticky ? "75px" : ""}`}}>
            <tr className="">
            {(selectedOption!=language.UI_MyRequests )?
              <th className="w-5p text-start">
              <div className="checkbox-style">
              <div className="checkbox left-14">
                  <label className="p-0 mb-0">
                    <input
                      type="checkbox"
                      ref={allCheckRef}
                      onChange={handlerMasterSelectionRequest}
                    />
                    <span className="cr">
                      <i className="cr-icon material-icons">check</i>
                    </span>
                  </label>
                </div>
              </div>

              </th>:''}
              <th className="w-5p type">{language.UI_Type}</th>
              <th className="w-14p pl-5px">{language.docID}</th>
              <th className="w-14p pl-5px">{language.subject}</th>
              <th className="w-14p pl-5px">{language.UI_DocumentName}</th>
              {(selectedOption!=language.UI_MyRequests )?
               <th className="w-16p pl-5px">{language.readers}</th>:''}
               {selectedOption === language.UI_MyRequests ? (
                <th className="w-16p pl-5px">
                  {selectedLanguage.LstLanguageCodes.UI_Owner}
                </th>
              ) : (
                ""
              )}
              <th className="w-14p pl-5px">{language.UI_RequestedDate}</th>
              <th className="w-10p pl-5px">{language.UI_Reason}</th>
              <th className="w-8p pl-5px">
                {selectedLanguage.LstLanguageCodes.UI_Status}
              </th>
            </tr>
          </thead>

          {/* </div> */}
          <tbody>
            {orgAutoLockLstPendingRequestAccess.length > 0 &&
              !noRecordsFoundPendingAccess &&
              orgAutoLockLstPendingRequestAccess.map((item, i) => (
                <>
                  <tr className={"borderrow"}>
                    <td colSpan={9} className="innertTableTd">
                      <table
                        className="table-layout aiAutolockTable"
                        cellPadding="0"
                        cellSpacing="0"
                      >
                        <tr
                          className={item.open == true ? "open view" : "view"}
                          onClick={(e) => rowclick(item.id)}
                          style={{ borderBottom: "0.1rem solid #e7e5e570" }}
                          id={"trMain" + i}
                        >
                          {(selectedOption!=language.UI_MyRequests)?
                          <td
                            className="w-5p text-start"
                            style={{ display: "" }}
                          >
                            <div className="checkbox mt-n5p marginTop8">
                              <label className="p-0 mb-0">
                                <input
                                  type="checkbox"
                                  ref={(el) => (ref.current[i] = el)}
                                  onChange={handleSelectedAllRequest}
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                              </label>
                            </div>
                          </td>:''}
                          <td
                            className="w-5p text-center"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            {item.rpdType !== undefined &&
                            item.rpdType === "Create" ? (
                              <img className="create-img"
                                src="assets/img/icons/create.svg"
                                height="28px"
                              />
                            ) : (
                              <span className="material-icons top3">mail </span>
                            )}
                          </td>
                          <td
                            className="w-14p pl-5px "
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div
                              className="d-flex flex-wrap Wordbreak"
                              title={item.documentId}
                            >
                              <p className="textwrap mb-0">{item.documentId}</p>
                            </div>
                          </td>
                          <td
                            className="w-14p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div
                              className="d-flex flex-wrap Wordbreak"
                              title={item.subject}
                            >
                              <p className="textwrap mb-0">{item.subject}</p>
                            </div>
                          </td>
                          <td
                            className="w-14p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div
                              className="d-flex flex-wrap Wordbreak"
                              title={item.documentName}
                            >
                              <p className="textwrap mb-0">
                                {item.documentName}
                              </p>
                            </div>
                          </td>
                          {(selectedOption!=language.UI_MyRequests)?
                          <td
                            className="w-16p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div
                              className="d-flex flex-wrap Wordbreak"
                              title={item.readerEmail}
                            >
                              <p className="textwrap mb-0">
                                {item.readerEmail != null && item.readerEmail}
                              </p>
                            </div>
                          </td>:''}
                          {selectedOption === language.UI_MyRequests ? (
                            <td
                              className="w-16p pl-5px"
                              style={{
                                borderLeft: "0.1rem solid #e7e5e570",
                              }}>
                              <div
                                className="d-flex flex-wrap Wordbreak"
                                title={item.senderEmail}>
                                <p className="textwrap mb-0">
                                  {item.senderEmail != null && item.senderEmail}
                                </p>
                              </div>
                            </td>
                          ) : (
                            ""
                          )}

                          <td
                            className="w-14p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div className="d-flex flex-wrap textwrap">
                              {
                                moment.utc(
                                  applyTimeZoneToDisplay(
                                   new Date(item.createdDate),
                                    timeZoneRef.current
                                  )
                                ).format(dateFormatValueUpper + " HH:mm")
                              }
                            </div>
                          </td>
                          <td
                            className="w-10p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div
                              className="d-flex flex-wrap Wordbreak"
                              title={item.readerNotes}
                            >
                              <p className="textwrap mb-0">
                                {item.readerNotes}
                              </p>
                            </div>
                          </td>
                          <td
                            className="w-8p pl-5px"
                            style={{
                              borderLeft: "0.1rem solid #e7e5e570",
                            }}
                          >
                            <div className="d-flex flex-wrap ">
                            {item.status === "Pending" ? selectedLanguage.LstLanguageCodes.UI_Pendingtxt: (item.status === "Approved" ? selectedLanguage.LstLanguageCodes.UI_Approvedtxt : selectedLanguage.LstLanguageCodes.UI_Declinedtxt)}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  {item.open == true && (
                    <tr className="fold open">
                      <td colSpan="9" className="">
                        <div
                          className="fold-content mb-3"
                          style={{
                            padding: "0em",
                            boxShadow: "none",
                          }}
                        >
                          <div className="row mt-4 mt-n1 mx-0 cardborder">
                            <div
                              className="bg-white mt-1"
                              style={{ width: "45%" }}
                            >
                              <table className="table table-borderless">
                                <tbody>
                                   <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_Owner
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.senderEmail}
                                                      </div>
                                                    </td>
                                                  </tr>
                                  <tr>
                                    <td className="w-38 border-0 font-lighter">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_ProductFeature
                                      }
                                      :
                                    </td>
                                    <td className="f-w550 border-0">
                                      <div className="d-flex flex-wrap textwrap">
                                        {item.productFeature != null &&
                                          item.productFeature=="Limit Readers"?selectedLanguage.LstLanguageCodes
                                          .UI_LimitReaders:(item.productFeature=="Track Readers"?selectedLanguage.LstLanguageCodes
                                            .UI_TrackReaders:selectedLanguage.LstLanguageCodes.UI_TrackViews)}
                                      </div>
                                    </td>
                                  </tr>
                                 <tr>
                                    <td className="w-38 border-0 font-lighter">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_RecipientIpAdress
                                      }
                                      :
                                    </td>
                                    <td className="f-w550 border-0">
                                      {item.recipientIp != null &&
                                        item.recipientIp}
                                    </td>
                                  </tr>

                                 <tr>
                                    <td className="w-38 border-0 font-lighter">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Loaction
                                      }
                                      :
                                    </td>
                                    <td className="f-w550 border-0">
                                      {item.location != null && item.location}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="w-38 border-0 font-lighter">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_Network
                                      }
                                      :
                                    </td>
                                    <td className="f-w550 border-0">
                                      {item.network != null && item.network}
                                    </td>
                                  </tr>
                                  {/* <tr>
                                    <td className="w-38 border-0 font-lighter">
                                      {
                                        selectedLanguage.LstLanguageCodes
                                          .UI_RequestedDate
                                      }
                                      :
                                    </td>
                                    <td className="f-w550 border-0">
                                      {moment(item.createdDate)
                                        .tz("UTC")
                                        .format(
                                          dateFormatValueUpper + " HH:mm"
                                        )}
                                    </td>
                                  </tr> */}
                                </tbody>
                              </table>
                            </div>
                             {item.status != "Pending" && (
                            <div
                              className="bg-white mt-1"
                              style={{
                                width: "45%",
                                borderLeft: "1px solid #d4d0d0a8",
                              }}
                            >
                              <table className="table table-borderless">
                                <tbody>
                                    {item.status != "Pending" && (
                                                                                <tr>
                                                                                  <td className="w-38 border-0 font-lighter">
                                                                                    {item.status == "Declined" ?
                                                                                      selectedLanguage.LstLanguageCodes
                                                                                        .UI_RejectedDate : selectedLanguage.LstLanguageCodes
                                                                                        .UI_OverriddenDate 
                                                                                    }
                                                                                    :
                                                                                  </td>
                                        <td className="f-w550 border-0">
                                          <div className="d-flex flex-wrap textwrap">
                                            {
                                              moment.utc(
                                                applyTimeZoneToDisplay(
                                                 new Date(item.modified),
                                                  timeZoneRef.current
                                                )
                                              ).format(dateFormatValueUpper + " HH:mm") +
                                              " " +"("+
                                              timeZoneAbbrevation.current+")"
                                            }
                                          </div>
                                        </td>
                                                                                </tr>
                                                                                )}
                                                                                {item.status != "Pending" && (
                                                                                <tr>
                                                                                  <td className="w-38 border-0 font-lighter">
                                                                                    {( item.status == "Declined" ?
                                                                                      selectedLanguage.LstLanguageCodes
                                                                                        .UI_RejectedBy :selectedLanguage.LstLanguageCodes.UI_OverriddenBy)
                                                                                    }
                                                                                    :
                                                                                  </td>
                                                                                  <td className="f-w550 border-0">
                                                                                    {(( item.status == "Declined" || item.status == "Approved") ? item.modifiedBy != null &&
                                                                                      item.modifiedBy:"")}
                                                                                  </td>
                                                                                </tr>
                                                                                )}
                                </tbody>
                              </table>
                            </div>
                             )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              ))}
            {noRecordsFoundPendingAccess && (
              <tr>
                <td colSpan={8} style={{ textAlign: "center" }}>
                  {language.UI_NoRecordsFound}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="row d-flex align-items-center justify-content-between">
        <p className="w-auto ms-3">
          <label
            htmlFor="pageView"
            className="radio-label font-w600 control res-w  res-left12"
            style={{ paddingTop: "9px", paddingRight: "5px" }}
          >
            {pageView}:
          </label>
          <select
            className=""
            name="documentIdInput"
            ref={pageViewRef}
            onChange={setpageViewDrp}
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </p>
        {totalPages > 1 ? (
          <Pagination
            {...paginationAttributes}
            onPrevClick={PrevClick}
            onNextClick={NextClick}
            onPageChange={(i) => PageChange(i)}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});
export default AIAutoLockPendingReqTable;
